export default __webpack_public_path__ + "7.ebc585.svg";